import React from "react";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";

const SideActions = withLiteObserverAndTheme<{ children: React.ReactNode }>(
  (props) => {
    const { children } = props;

    return (
      <ET3Div
        width={200}
        height={428}
        alignItems={"center"}
        fDirection={"column"}
        style={{}}
        color={""}
        justifyContent={"space-around"}
        withShadow={false}
        isExtendable={false}
        isScrollable={false}
        onClick={() => {}}
      >
        {children}
      </ET3Div>
    );
  }
);

export default SideActions;
